<header>
	<app-header></app-header>
</header>

<main>
	<app-tvbox/>
</main>

<aside class="chat-wrapper">
	<app-chat></app-chat>
</aside>

<section class="schedule-wrapper predictions-wrapper">
	<app-schedule/>
</section>

<nav>
	<button class="route" (click)="core.redirectTo('/', true)" [class.selected]="core.url_path == '/'" >
		Betting Simulator
		<!--span class="money-peek">${{ core.user.balance | moneyPipe }}</span-->
		<span class="bottom-bookmark"></span>
	</button>

	<button class="route" (click)="core.redirectTo('/top-rankings', true)" [class.selected]="core.url_path == '/top-rankings'">
		Stats & History
		<span class="bottom-bookmark"></span>
	</button>

	<!-- <button class="route disabled soon"> -->
	<!-- <button class="route soon" (click)="core.redirectTo('/time-machine', true)" [class.selected]="core.url_path == '/time-machine'"> -->
	<button class="route disabled soon">
		Time Machine
		<i class="material-icons">construction</i>
		<span class="bottom-bookmark"></span>
	</button>

	<!--button class="route" (click)="core.redirectTo('/diagnostics', true)" [class.selected]="core.url_path == '/diagnostics'" *ngIf='core.chat_user && core.chat_user.role=="admin"'>
		Diagnostics
		<span class="bottom-bookmark"></span>
	</button-->
</nav>

<section class="router-wrapper">
	<router-outlet></router-outlet>
</section>

<footer class="footer-wrapper">
	<app-footer></app-footer>
</footer>
